$(document).ready(function () {

	const state = {
		zip: parseInt(localStorage.getItem("zipcode")) || null
	};

	function QuoteForm () {
		state.zipData = null;

		let $quoteForm = $('.sb-quote-form');
		
		function validateZip ($input) {
			if ($input) {
				if ($input.val().toString().length == 5) {
					let entry = state.zipData.find(item => item.zip == $input.val());
					let schedule = entry["Shipment Schedule"];

					if (entry && schedule && schedule != 'No shipment') {
						state.zip = entry.zip;
						return true;
					}
				}
			}
			return false;
		}

		$quoteForm.each(function () {
			let $input = $(this).find('.sb-quote-form__input');

			$(this).submit(function (e) {
				e.preventDefault();
				let zipCode = $input.val();

				$.get( "//www.getpestremedy.com/cdn/shop/t/24/assets/zipcodes.json?v=120884804956811048891778524508").done(function (data) {
					state.zipData = data;
					
					localStorage.setItem('zipcode', zipCode);
					if (validateZip($input)) {
						setTimeout(function () {
							let url = (state.schedule == 'Bi-monthly') ? '/products/HS1-BM-PAYG' : '/products/HS1-MO-PAYG';
							location.href = url;
						}, 500);
					} else {
						location.href = '/pages/zip-code#zip-error';
					}
				});
			});
		});
	}

	function ZipPage () {
		state.zipData = null;

		let $input = $('.sb-quiz-page__zip-input');
		let $message = $('.sb-quiz-page__message');
		let $nextBtn = $('.sb-quiz-page__next-btn');

		// Populate input if zip code exists
		if (state.zip) {
			$input.val(state.zip);
		}

		// Show message when newsletter form has been submitted
		if (location.hash == '#zip-error') {
			$message.show();
			$message.css('visibility', 'visible');
		}

		function enableNextBtn () {
			let url = (state.schedule == 'Bi-monthly') ? '/products/HS1-BM-PAYG' : '/products/HS1-MO-PAYG';
			$nextBtn.attr('href', url).removeClass('disabled');
		}

		function disableNextBtn () {
			$nextBtn.attr('href', 'javascript:;').addClass('disabled');
		}

		function validateZip () {
			if ($input.val().toString().length == 5) {
				let entry = state.zipData.find(item => item.zip == $input.val());
				if (!entry) {
					return;
				}
				let schedule = entry["Shipment Schedule"];

				if (!schedule) {
					state.zip = null;
					disableNextBtn();
					$message.hide();
				} else if (schedule == 'No shipment') {
					state.zip = null;
					disableNextBtn();
					$message.show();
					$message.css('visibility', 'visible');
				} else {
					state.zip = entry.zip;
					state.schedule = schedule;
					enableNextBtn();
					$message.hide();
					return true;
				}
			} else {
				disableNextBtn();
				$message.hide();
			}
			return false;
		}

		$.get( "//www.getpestremedy.com/cdn/shop/t/24/assets/zipcodes.json?v=120884804956811048891778524508").done(function (data) {
			state.zipData = data;
			validateZip();
			$input.on('propertychange change click keyup input paste', function () {
				validateZip();
			});
		});

		$nextBtn.click(function (e) {
			e.preventDefault();
			if (validateZip()) {
				localStorage.setItem('zipcode', state.zip);
				location.href = $(this).attr('href');
			}
		});



	}

	function FloorPlansPage () {
		state.stories = $('.sb-big-radio__input[name="stories"]:checked').val() || null;
		state.sqft = $('.sb-big-radio__input[name="sqft"]:checked').val() || null;
		state.size = null;
		state.schedule = null;
		state.nextUrl = null;

		let $nextBtn = $('.sb-quiz-page__next-btn');
		let $bigRadioInput = $('.sb-big-radio__input');
		let $description = $(".sb-quiz-page__description");

		if (!state.zip) {
			location.href = '/pages/zip-code';
			return false;
		}

		function updateNextUrl () {
			// Get size
			(state.stories == 'single_story' && state.sqft == 'less_2000') ? state.size = 1 : null;
			(state.stories == 'multi_story' && state.sqft == 'less_2000') ? state.size = 1 : null;
			(state.stories == 'multi_story' && state.sqft == '2000_5000') ? state.size = 1 : null;
			(state.stories == 'single_story' && state.sqft == '2000_5000') ? state.size = 2 : null;
			(state.stories == 'multi_story' && state.sqft == 'more_5000') ? state.size = 2 : null;
			(state.stories == 'single_story' && state.sqft == 'more_5000') ? state.size = 3 : null;

			// Get URL from size & schedule
			// HS1 (size 1) → HS1 products
			// HS2 (size 2) → HS1 products (routed down one tier)
			// HS3 (size 3) → HS2 products (routed down one tier)
			(state.size == 1 && state.schedule == 'Bi-monthly') ? state.nextUrl = '/products/HS1-BM-PAYG' : null;
			(state.size == 2 && state.schedule == 'Bi-monthly') ? state.nextUrl = '/products/HS1-BM-PAYG' : null;
			(state.size == 3 && state.schedule == 'Bi-monthly') ? state.nextUrl = '/products/HS2-BM-PAYG' : null;
			(state.size == 1 && state.schedule == 'Monthly') ? state.nextUrl = '/products/HS1-MO-PAYG' : null;
			(state.size == 2 && state.schedule == 'Monthly') ? state.nextUrl = '/products/HS1-MO-PAYG' : null;
			(state.size == 3 && state.schedule == 'Monthly') ? state.nextUrl = '/products/HS2-MO-PAYG' : null;

			$nextBtn.attr('href', state.nextUrl).removeClass('disabled');
		}

		$.get( "//www.getpestremedy.com/cdn/shop/t/24/assets/zipcodes.json?v=120884804956811048891778524508", function( data ) {
			let entry = data.find(item => item.zip == state.zip);
			let schedule = entry["Shipment Schedule"];
			let city = entry["primary_city"];
			let _state = entry["state"];

			if (!entry || !schedule) {
				location.href = '/pages/zip-code';
			} else if (schedule == 'No shipment') {
				location.href = '/pages/zip-code?noship=true';
			}

			state.schedule = schedule;
			$description.html($description.html().replace('.', ' in '+city+', '+_state+'.'));

		}).done(updateNextUrl).fail(function () {
			location.href = '/pages/zip-code';
		});

		$bigRadioInput.change(function () {
			if ($(this).attr('name') == 'stories') {
				state.stories = $(this).val();
			}
			if ($(this).attr('name') == 'sqft') {
				state.sqft = $(this).val();
			}

			updateNextUrl();
			console.log(state);
		});
	}

	QuoteForm();
	if (location.href.indexOf('/pages/zip-code') > -1) {
		ZipPage();
	}
	if (location.href.indexOf('/pages/floor-plans') > -1) {
		FloorPlansPage();
	}

});




// IP ZIP LOOKUP — pre-fill zip on homepage, auto-advance on zip page
function IPZipLookup() {
  // Skip if zip already known
  if (localStorage.getItem('zipcode')) return;

  // Only run on homepage or zip page
  const onHomepage = location.pathname === '/' || location.pathname === '/index';
  const onZipPage = location.pathname.indexOf('/pages/zip-code') > -1;
  if (!onHomepage && !onZipPage) return;

  fetch('https://ipapi.co/json/')
    .then(function(response) { return response.json(); })
    .then(function(data) {
      const zip = data.postal;
      if (!zip || zip.length < 5) return;

      $.get("//www.getpestremedy.com/cdn/shop/t/24/assets/zipcodes.json?v=120884804956811048891778524508").done(function(zipData) {
        const entry = zipData.find(function(item) { return item.zip == zip; });
        if (!entry) return;

        const schedule = entry["Shipment Schedule"];
        if (!schedule || schedule === 'No shipment') return;

        // Store zip and schedule
        localStorage.setItem('zipcode', zip);
        localStorage.setItem('zipschedule', schedule);

        if (onHomepage) {
          // Pre-fill the quote form input — do not redirect
          $('.sb-quote-form__input').val(zip);
        } else if (onZipPage) {
          // Auto-advance on zip page
          const url = (schedule === 'Bi-monthly') ? '/products/HS1-BM-PAYG' : '/products/HS1-MO-PAYG';
          location.href = url;
        }
      });
    })
    .catch(function() {
      // API failed — do nothing, user goes through normal flow
    });
}

// CTA INTERCEPT — if zip is known, route "Customize Your Kit" / "Get Your Kit"
// links directly to the product page instead of the zip page
function getProductUrlFromZip(callback) {
  const zip = localStorage.getItem('zipcode');
  if (!zip) { callback(null); return; }

  // Use cached schedule if available
  const cached = localStorage.getItem('zipschedule');
  if (cached) {
    const url = (cached === 'Bi-monthly') ? '/products/HS1-BM-PAYG' : '/products/HS1-MO-PAYG';
    callback(url);
    return;
  }

  // Otherwise look up from zipcodes.json
  $.get("//www.getpestremedy.com/cdn/shop/t/24/assets/zipcodes.json?v=120884804956811048891778524508").done(function(zipData) {
    const entry = zipData.find(function(item) { return item.zip == zip; });
    if (!entry || !entry["Shipment Schedule"] || entry["Shipment Schedule"] === 'No shipment') {
      callback(null);
      return;
    }
    const schedule = entry["Shipment Schedule"];
    localStorage.setItem('zipschedule', schedule);
    const url = (schedule === 'Bi-monthly') ? '/products/HS1-BM-PAYG' : '/products/HS1-MO-PAYG';
    callback(url);
  }).fail(function() { callback(null); });
}

$(document).ready(function() {
  IPZipLookup();

  // Intercept clicks on links to the zip page, or on the "Customize Your Kit" CTA
  // Matches by href AND by visible text (fallback in case href is empty or formatted differently)
  $(document).on('click', 'a', function(e) {
    var href = $(this).attr('href') || '';
    var isZipLink = href.indexOf('/pages/zip-code') > -1;

    var linkText = $.trim($(this).text());
    var navText = $.trim($(this).find('.navtext').text());
    var isCustomizeCta = (linkText === 'Customize Your Kit' || navText === 'Customize Your Kit');

    if (!isZipLink && !isCustomizeCta) return;

    var onHomepage = location.pathname === '/' || location.pathname === '/index';

    if (onHomepage) {
      e.preventDefault();
      var zip = localStorage.getItem('zipcode');
      if (zip) {
        // IP lookup already stored a valid zip — route directly to product page
        getProductUrlFromZip(function(url) {
          location.href = url || '/pages/zip-code';
        });
      } else {
        // No zip stored yet — scroll to the quote form so user can enter one
        var $qf = $('.sb-quote-form').first();
        if ($qf.length) {
          $('html, body').animate({ scrollTop: $qf.offset().top - 100 }, 400, function() {
            $qf.find('.sb-quote-form__input').focus();
          });
        }
      }
      return;
    }

    // On other pages, route directly if zip is known
    var zip = localStorage.getItem('zipcode');
    if (!zip) return; // no zip stored, let the link go through normally

    e.preventDefault();
    getProductUrlFromZip(function(url) {
      location.href = url || '/pages/zip-code';
    });
  });
});

// T&C Checkbox
$(document).ready(function() {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
  });
});

// Bug options
$(document).ready(function() {
  $('body').on('change', '#bug-option', function(e) {
    const optionText = e.target.value.toString() || '';
    window
      .fetch(`${window.theme.routes.cart}/update.js`, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          attributes: {
            'bug_option': optionText
          }  
        }),
      })
      .catch((e) => {
        console.error(e);
      });
  });
});




// PREVENT CART ICON FROM NAVIGATING TO /cart PAGE — open drawer instead
$(document).on('click', '[data-drawer-toggle="drawer-cart"]', function(e) {
  const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
  if (cartDrawer) {
    e.preventDefault();
    cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:toggle', { bubbles: false }));
  }
});

// TRIGGER CART DRAWER ON ATC

function cartDrawer () {
	const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');

	const onSuccess = function (e) {
		document.addEventListener('theme:cart:change', onChange);
	};

	const onChange = function (e) {
		cartDrawer.dispatchEvent(
			new CustomEvent('theme:drawer:open', {
				bubbles: false,
			})
		);
		document.removeEventListener('theme:cart:change', onChange);
	};

	if (cartDrawer) {
		document.addEventListener('theme:cart:success', onSuccess);
	}
}

$(document).ready(function () {
	cartDrawer();
})







